import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import {
  Button, Display, Header, KDSButton, Spacer, Text,
} from '@kueski-dev/kueski-design-system';

import Urls from 'Containers/Urls';
import { cleanSession } from 'Utils/session';

import SendMail from './sending-mail.svg';
import EnvelopAlert from './envelop-alert.svg';
import { CardContainer, UnderlineButton } from '../EmailVerification.styles';
import { sendCheckVerifiedClicked, sendCreateNewAccountClicked } from '../events';

interface ISendEmailUI {
  isDefaultMessage: boolean;
  email: string;
  onResend(): void;
  onVerified(): void;
  showVerifiedButton: boolean;
  resendDisabled: boolean;
  verifiedDisabled: boolean;
  countDown: string;
}

export const SendEmailUI: React.FC<ISendEmailUI> = ({
  isDefaultMessage,
  email,
  onResend,
  onVerified,
  showVerifiedButton,
  resendDisabled,
  verifiedDisabled,
  countDown,
}) => {
  const { logout } = useAuth0();

  const createNewAccount = () => {
    sendCreateNewAccountClicked();
    cleanSession();
    logout({
      logoutParams: {
        returnTo: `${window.location.origin}${Urls.signUp}`,
      },
    });
  };

  const checkVerifiedEmail = () => {
    sendCheckVerifiedClicked();
    onVerified();
  };

  return (
    <CardContainer>
      {isDefaultMessage ? (
        <>
          <EnvelopAlert />
          <Spacer $size="spacing07" />
          <Header $align="center" $format="Title/Large/Bold">
            Revisa tu correo
          </Header>
          <Spacer $size="spacing05" />
          <Text $align="center" $color="textSecondary" $format="Body/Large/Regular">
            <span>Abre el correo que te enviamos y selecciona</span>
            {' '}
            <b>Confirmar correo</b>
            {' '}
            <span>para continuar tu registro. Sigue los pasos que te enviamos por correo.</span>
          </Text>
        </>
      ) : (
        <div className="text-left">
          <SendMail />
          <Spacer $size="spacing07" />
          <Header $align="left" $format="Title/Large/Bold">
            Verifica tu correo electrónico
          </Header>
          <Spacer $size="spacing05" />
          <Text $align="left" $color="textSecondary" $format="Body/Large/Regular">
            <span>
              Para realizar la verificación, sigue los pasos del correo que te enviamos a
            </span>
            {' '}
            <b>{email}</b>
            {'. '}
            <span>Si no lo encuentras, revisa Spam o tus correos no deseados.</span>
          </Text>
          <Spacer $size="spacing04" />
          <Display $on="flex">
            <Header $align="center" $format="Title/Small/Medium">
              ¿No es tu correo?
            </Header>
            <UnderlineButton
              $type={KDSButton.LINK}
              type="button"
              onClick={createNewAccount}
            >
              Crea una nueva cuenta.
            </UnderlineButton>
          </Display>
        </div>
      )}
      <Spacer $size="spacing07" />
      {showVerifiedButton && (
        <Display $on="block">
          <Button
            $type={KDSButton.PRIMARY}
            $wide
            disabled={verifiedDisabled}
            type="button"
            onClick={checkVerifiedEmail}
          >
            Correo verificado
          </Button>
          <Spacer $size="spacing04" />
        </Display>
      )}
      <Display $on="grid">
        <Button
          $type={showVerifiedButton ? KDSButton.NAV : KDSButton.PRIMARY}
          $wide
          type="button"
          disabled={resendDisabled}
          onClick={onResend}
        >
          Reenviar correo
          {countDown}
        </Button>
      </Display>
    </CardContainer>
  );
};
